module.exports = __webpack_public_path__ + "static/basics-product-72eb35d82ff853483cf385dd69e94635.png";